import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { TaskService } from '@app/_components/task';
import { AlertService } from '@app/_services';


@Component({
    selector: 'app-user-select',
    template: `
<form [formGroup]="userSelectForm">
  <mat-form-field class="flex-1">
    <mat-label>{{customPlaceholder}}</mat-label>
    <mat-select placeholder="{{customPlaceholder}}" formControlName="userId"  #str (selectionChange)="onUserSelect(str.value)">
      @for (order of user; track order; let i = $index) {
        <mat-option [value]="user[i].userId">
          {{user[i].lastName}}, {{user[i].firstName}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>
`,
    styles: [],
    standalone: false
})
export class UserSelectComponent implements OnInit, OnChanges
{

	userSelectForm: UntypedFormGroup;
	formLoading = false;
	user = [];
	@Output() messageEvent = new EventEmitter<string>();
	@Input() taskId: number;
	@Input() userId: number;
	@Input() customPlaceholder: string;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		private taskService: TaskService,
		private alertService: AlertService) { }
	ngOnInit()
	{
		this.userSelectForm = this.formBuilder.group({
			userId: [this.userId],
			taskId: [this.taskId]
		});

		this.findUsers();
	}
	findUsers()
	{
		this.reportService.userSummaryList(200).pipe(first()).subscribe(

			data =>
			{
				// console.log('reports are: ' + JSON.stringify(data));
				this.user = data.data.userSummaryList;
			},
			error =>
			{
				// console.log('user-select ERROR: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}


	formUpdate()
	{
		try
		{
      if ( true ) return;
			// stop here if form is invalid
			// console.log('Form Submitted: ' + JSON.stringify(this.userSelectForm.value));
			if (this.userSelectForm.invalid)
			{
				// console.log('Form Invalid: ' + JSON.stringify(this.userSelectForm.getError));
				return;
			}

			this.formLoading = true;
			this.taskService.updateAssignedToUserId(this.userSelectForm.value)
				.subscribe(
					res =>
					{
						// console.log('Task-Update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						// this.router.navigate(['/task-view', this.form1.value.taskId]);
					},
					err =>
					{
						// console.log('Task-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/**
     *
     * method to update parent component
     */


	onUserSelect(value)
	{
		// console.log('User Fired1 ' + value);
		// update
		if (this.taskId == null)
		{
			this.alertService.error('Please enter a task name first');
		}
		else
		{
			this.formUpdate();
		}
		this.messageEvent.emit(this.userSelectForm.value);
	}

	/**
     *
     * helper method to update this component from parent
     */
	setUserId(assignedToUserId: number)
	{
		// console.log('assignedToUserId Fired2 ' + assignedToUserId);
		//this.assignedToUserId = assignedToUserId;
	}
	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.userSelectForm !== undefined)
		{
			this.userSelectForm.patchValue({ taskId: this.taskId });
		}
	}
}
